import { MILLISECONDS_PER_DAY } from '@kwenta/sdk/constants'
import { PerpsProvider } from '@kwenta/sdk/types'

// Shows or hides the home page banner entirely when set to true/false
export const BANNER_ENABLED = true
// Sets the link destination for the banner component, or renders the banner as
// plain, un-clickable text if set to a falsey value (`false`, `null`, '', etc...)
export const BANNER_LINK_URL = {
	[PerpsProvider.SNX_V3_BASE]: '',
	[PerpsProvider.SNX_V2_OP]: '',
}
// Sets the text displayed on the home page banner
export const BANNER_TEXT = {
	[PerpsProvider.SNX_V3_BASE]:
		'Start your 1-Click trading session today and experience seamless, zero-cost trading on Base.',
	[PerpsProvider.SNX_V2_OP]:
		'Start your 1-Click trading session today and experience seamless, zero-cost trading on Optimism.',
}
// Sets the height of the banner component on desktop
export const BANNER_HEIGHT_DESKTOP = 40
// Sets the height of the banner component on mobile
export const BANNER_HEIGHT_MOBILE = 50
// Sets the waiting time of the banner component before it is reactive
export const BANNER_WAITING_TIME = 2 * MILLISECONDS_PER_DAY
